import React from "react";
import { CLASS_NAME_PREFIX } from "../constants";
export var Root = function Root(_a) {
  var children = _a.children,
      className = _a.className;
  return React.createElement("div", {
    className: "" + CLASS_NAME_PREFIX + (className ? " " + className : "")
  }, children);
};